import { axiosHrClient } from "../plugins/axios";

const navbar = {
  namespaced: true,

  state: {
    visible: true,
    status: true,
    list: [],
  },

  mutations: {
    UPDATE_INVISIBLE(state) {
      state.visible = false;
      state.status = false;
      state.list = [];
    },
    UPDATE_VISIBLE(state, payload) {
      state.visible = payload;
    },
    UPDATE_STATUS(state, payload) {
      state.status = payload;
    },
    UPDATE_LIST(state, payload) {
      state.list = payload;
    },
  },

  actions: {
    getUserMenus() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get("/hrportal/self/catelogroles");
          resolve(res);
        } catch (e) {
          reject(e);
        }
      });
    },

    getUserRoles() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get("/hrportal/self/accessroles");
          resolve(res);
        } catch (e) {
          reject(e);
        }
      });
    },
  },

  getters: {},
};

export default navbar;
